import { render, staticRenderFns } from "./addBuyer.vue?vue&type=template&id=2d7465a0&scoped=true&"
import script from "./addBuyer.vue?vue&type=script&lang=js&"
export * from "./addBuyer.vue?vue&type=script&lang=js&"
import style0 from "./addBuyer.vue?vue&type=style&index=0&id=2d7465a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7465a0",
  null
  
)

export default component.exports